import { Company } from "../enums/Company";

export class AdAccountPermissionsRequest{
    public AdAccountId!: string;
    public Company!: Company;
}